import React, { useMemo } from "react";
import { useGoogleFonts } from "@/hooks/useGoogleFonts";
import Select, { SelectItem } from "./Select";

interface Props {
  font: string | undefined;
  onSelect: (f: string) => void;
}

const FontSelector = ({ font, onSelect }: Props) => {
  const { fonts } = useGoogleFonts();
  const data: SelectItem[] = useMemo(() => {
    const formatted = fonts.map((f) => ({
      value: f.family,
      label: f.family,
    }));
    const sorted = formatted.sort((a, b) => a.value.localeCompare(b.value));
    return sorted;
  }, [fonts]);
  return <Select label="Font" value={font} items={data} onChange={onSelect} />;
};

export default FontSelector;
